import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  isSafari, isChrome, isEdge, isIOS,
} from 'core/utils/helpers/browser';
import ChromeRating from 'core/modules/Partials/ChromeRating/ChromeRating';

import { selectToolbarConfig } from 'core/selectors/app';
import { selectIsMobileMQ, selectIsMobileOrTabletMQ, selectIsDesktopMQ } from 'core/modules/MediaQueries/selectors';
import { selectButtonConfigViewData } from './selectors';
import { triggerOnboardingButtonChoiceClicked } from '../../actions/index';
import SlideCounter from '../SlideCounter/SlideCounter';
import SlideMessage from '../SlideMessage/SlideMessage';
import { BUTTON_MOBILE_MESSAGE, BUTTON_DESKTOP_MESSAGE } from '../SlideMessage/utils/constants';

function Button({ handleButtonDoneClick, sequenceValue, stepsData }) {
  const dispatch = useDispatch();

  const viewData = useSelector(selectButtonConfigViewData);
  const toolbarConfig = useSelector(selectToolbarConfig);
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const isDesktopMQ = useSelector(selectIsDesktopMQ);
  const isMobileOrTabletMQ = useSelector(selectIsMobileOrTabletMQ);
  const { chromeDownloadUrl, safariDownloadUrl, mobileButtonIOSDownloadUrl } = toolbarConfig || {};

  const handleButtonChoiceClickWithAnalyticsAction = (isGetButton) => {
    // To prevent blocking pop-up in Chrome, a button tab should be opened right after user click
    if (isGetButton && chromeDownloadUrl && (isChrome || isEdge)) {
      window.open(chromeDownloadUrl, '_blank');
    }

    if (isGetButton && isSafari) {
      window.open(safariDownloadUrl, '_blank');
    }

    if (isGetButton && isIOS) {
      window.open(mobileButtonIOSDownloadUrl, '_blank');
    }

    const action = isGetButton ? 'Button download' : 'Button get later click';
    dispatch(triggerOnboardingButtonChoiceClicked(action, sequenceValue));
    handleButtonDoneClick();
  };

  const {
    getButtonHeader, rewardsType, getButtonDescription,
    secondBulletText, customThirdBulletText, starsSvg, chromeText,
    mobileButtonHeader, mobileButtonDescription, mobileButtonImg,
    mobileButtonCTA, mobileButtonLaterText, getButtonLaterText,
    getAddButtonText,
  } = viewData;

  const buttonHeader = getButtonHeader(isMobileMQ);
  const buttonDescription = getButtonDescription(isMobileMQ);
  const buttonLaterText = getButtonLaterText(isMobileMQ);
  const addButtonText = getAddButtonText(isMobileMQ);

  if (mobileButtonIOSDownloadUrl && isMobileMQ && isIOS) {
    return (
      <div className="mn_slide mn_slideMobileButton">
        <SlideMessage step={BUTTON_MOBILE_MESSAGE} />
        <div className="mn_content">
          <SlideCounter stepsData={stepsData} />
          <div className="mn_gap" />
          <div className="mn_buttonMobileImage" />
          <h2>{mobileButtonHeader}</h2>
          <div className="mn_description">
            {mobileButtonDescription && <p>{mobileButtonDescription}</p>}
          </div>
          <div className="mn_bottomContent">
            <button
              className="mn_button mn_stepButton mn_stepButtonDone"
              onClick={() => handleButtonChoiceClickWithAnalyticsAction(true)}
            >
              {mobileButtonCTA} <img className="mn_icon" src={mobileButtonImg} alt="Apple icon" />
            </button>
            <button
              className="mn_basicButton mn_stepLaterLink"
              onClick={() => handleButtonChoiceClickWithAnalyticsAction(false)}
            >
              {mobileButtonLaterText}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mn_slide mn_slideButton">
      <SlideMessage step={isMobileOrTabletMQ ? BUTTON_MOBILE_MESSAGE : BUTTON_DESKTOP_MESSAGE} />
      <div className="mn_content">
        <SlideCounter stepsData={stepsData} />
        <div className="mn_gap" />
        {isMobileMQ && <div className="mn_buttonImage" />}
        <h2>{buttonHeader}</h2>
        {buttonDescription && <p>{buttonDescription}</p>}
        <div className="mn_description">
          {!isMobileMQ && <div className="mn_buttonImage" />}
          <ul>
            <li>Never forget to earn {rewardsType(isDesktopMQ)} - the button reminds you</li>
            <li>{secondBulletText}</li>
            <li>{customThirdBulletText}</li>
            {(isChrome || isEdge) &&
              <li className="mn_chromeItem">
                <ChromeRating
                  chromeText={chromeText}
                  storeRatingImage={starsSvg}
                />
              </li>
            }
          </ul>
        </div>
        <div className="mn_bottomContent">
          <button
            className="mn_button mn_stepButton mn_stepButtonDone"
            onClick={() => handleButtonChoiceClickWithAnalyticsAction(true)}
          >
            {addButtonText}
          </button>
          <button
            className="mn_basicButton mn_stepLaterLink"
            onClick={() => handleButtonChoiceClickWithAnalyticsAction(false)}
          >
            {buttonLaterText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Button;
